import React, { Component } from 'react';
import _ from 'lodash';

import ParkinglocationGroupsTable from '../components/ParkinglocationGroupsTable';
import ParkinglocationGroupsForm from '../components/ParkinglocationGroupsForm';

import ParkinglocationGroupsModel from '../components/ParkinglocationGroupsModel';
import UserModel from '../components/UserModel';

import { Layout, Button, Row, Col, Input, Icon } from 'antd';

class SettingsParkinglocationGroupsScreen extends Component {

  state = {
    dataLoading: true,
    dataAll: [],
    data: [],
    modalVisible: false,
    formDefaultValues: null,
  }

  componentWillMount() {
    this.loadData();
  }

  loadData(force = false) {
    this.setState({
      dataLoading: true
    });
    ParkinglocationGroupsModel.getAll(force)
      .then(data => {
        this.setState({
          dataLoading: false,
          dataAll: data,
          data: data
        });
      });
  }

  onSearch(searchText) {
    const dataAll = this.state.dataAll;
    this.setState({
      data: _.filter(dataAll, (d) => { return d['name'].startsWith(searchText); })
    })
  }

  render() {
    return (
      <Layout.Content style={{ margin: '24px 16px 0' }}>
        <div style={{ padding: 24, background: '#fff', minHeight: 360 }}>
          <h2>Systém - Seznam skupin</h2>
          <div style={{ marginBottom: '20px' }}>
            <Row>
              <Col span={8}>
                <Input.Search
                  placeholder="Název skupiny"
                  onSearch={this.onSearch.bind(this)}
                  style={{ width: 300 }} />
              </Col>
              <Col span={8} offset={8} style={{ textAlign: 'right' }}>
                <Button type="default" onClick={() => { this.loadData(true) }} style={{ marginRight: 10 }}><Icon type="sync" /></Button>
                {UserModel.isInRoles(['ADMIN', 'CORE_PARKINGLOCATIONSGROUPS_WRITE'])
                  ? <Button type="default" onClick={() => { this.setState({ modalVisible: true }) }}>Nová skupina</Button>
                  : null}
              </Col>
            </Row>
          </div>
          <ParkinglocationGroupsForm
            type="modal"
            title="Vytvoření nové skupiny lokalit"
            modalVisible={this.state.modalVisible}
            defaultValues={this.state.formDefaultValues}
            onModalCancel={() => {
              this.setState({
                modalVisible: false,
                formDefaultValues: null
              });
            }}
            onSuccess={(form, values) => {
              ParkinglocationGroupsModel.create(values)
                .then(() => {
                  form.resetFields();
                  this.loadData(true);
                });
            }} />
          <ParkinglocationGroupsTable
            data={this.state.data}
            loading={this.state.dataLoading}
            onDetailRow={(record) => {
              this.setState({
                modalVisible: true,
                formDefaultValues: record
              });
            }}
            onRemoveRow={(id) => {
              ParkinglocationGroupsModel.remove(id)
                .then(() => {
                  this.loadData(true);
                });
            }}
            onAnyFormSuccess={() => {
              this.loadData(true);
            }} />
        </div>
      </Layout.Content>
    );
  }
}

export default SettingsParkinglocationGroupsScreen;



// WEBPACK FOOTER //
// ./src/screens/SettingsParkinglocationGroupsScreen.js